module.exports = __webpack_public_path__ + "static/img/camera.2b23b031.png";